import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fd1fe54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-list" }
const _hoisted_2 = { class: "mt-1 new-opportunity-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus new-opportunity-icon" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opportunities, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "loop-box"
      }, [
        (item.isNewOpportunity)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "new-opportunity-card",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNewOpportunity()))
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(item.title), 1),
              _hoisted_3
            ]))
          : (_openBlock(), _createBlock(_component_Card, {
              key: 1,
              imageNameTitle: _ctx.getImageNameTitle(item.controle_status !== 'analise' ? item.title : item.tipo),
              title: item.controle_status !== 'analise' ? item.title : item.tipo,
              status: item.controle_status,
              cityAndState: `${item.cidade} - ${item.estado}`,
              location: `${item.logradouro} - ${item.bairro}`,
              areaLote: item.area_lote,
              recommendation: item.tags.length > 0 ? item.tags[0].descricao : '',
              biURL: item.url,
              gidImovel: item.gid_imovel,
              nearby: item.tags[1] ? item.tags[1].descricao : '',
              iconLeft: item.tags.length > 0 ? item.tags[0].tagenum : 'default-left-icon',
              iconRight: item.tags.length > 1 ? item.tags[1].tagenum : 'default-right-icon',
              "image-map-name": item.image,
              "tag-vgv": "VGV",
              "tag-vgv-value": item.vgv ? _ctx.formatVgvValue(item.vgv) : null,
              "tag-roi": "ROI",
              "tag-roi-value": item.roi ? item.roi + '%' : null,
              "tag-vgv-color": "#bca9f5",
              id: item.id_bis,
              class: "lcts-card-component"
            }, null, 8, ["imageNameTitle", "title", "status", "cityAndState", "location", "areaLote", "recommendation", "biURL", "gidImovel", "nearby", "iconLeft", "iconRight", "image-map-name", "tag-vgv-value", "tag-roi-value", "id"]))
      ]))
    }), 128))
  ]))
}